import { useQuery } from "@tanstack/react-query"
import { formatCurrency } from "../../../shared/utils";
import { forecastVarianceApi } from "../api/forecastVarianceApi";

export const useScopeChangeState = () => {

    const { data, isLoading, isFetching, error, isError } = useQuery({
        queryKey: ["investment-oversight-scope-change-state"],
        queryFn: async () => {
            const response = await forecastVarianceApi.fetchScopeChangeStates();
            return response.data;
        }
    });

    return {
        data: {
            totalChanges: formatCurrency(data?.total_changes),
            netScopeImpact: `${data?.net_scope_impact_percent}%`,
            totalForecastVariance: formatCurrency(data?.total_forecast_variance),
            avgVariance: `${data?.avg_variance_percent}%`,
        },
        isLoading: isLoading || isFetching, error, isError
    }

}